import {
  Component,
  OnInit,
  ComponentRef,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  ChangeDetectorRef,
  OnDestroy
} from '@angular/core';
import { IMenu } from '../models/imenu.model';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { EventListenerService } from '../services/close-listenenr.service';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { MyoderService } from './shared/myoder.service';
import { filter } from 'rxjs/operators';
import { ExternalScriptService } from '../services/external-script.service';

declare var $: any;

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.css']
})
export class MyOrdersComponent implements OnInit, OnDestroy {
  MENULIST: IMenu[] = [
    {
      menuName: 'Open Orders',
      menuRouter: 'openorders'
    },
    // {
    //   menuName: 'BACK ORDERS',
    //   menuRouter: 'backorders'
    // },
    {
      menuName: 'Recently Invoiced Orders',
      menuRouter: 'shippedorders'
    }
    // {
    //   menuName: 'Search Invoiced Orders',
    //   menuRouter: 'searchorders'
    // },
  ];

  title = 'Orders';
  created = false;
  // the component can be any instance of the child component in the second menu
  component: ComponentRef<any>;

  // tslint:disable-next-line:no-trailing-whitespace
  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent; // reference to the breadcrumb

  

  // css variable
  setFullWindow = false;
  subWidth: string;

  searchField = '';

  constructor(
    private closeListener: EventListenerService,
    private resolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef,
    private externalScriptService: ExternalScriptService,
    private activeRouter: ActivatedRoute,
    private orderService: MyoderService,
    private router: Router,
  ) {
  }

  ngOnInit() {

    this.externalScriptService
      .loadScript('https://api.payway.com.au/rest/v1/payway.js')
      .then(() => {
        this.externalScriptService.runMyScript();
      })
      .catch((error) => console.error(error));

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(res => {
      this.breadcrumbRef.ngAfterViewInit();
    });


    this.router.events.pipe(filter(value => value instanceof NavigationEnd))
      .subscribe((value: any) => {
        const currentUrl = this.router.url;
        if (currentUrl !== '/myOrder/shippedorders' && currentUrl !== '/myOrder/openorders' && currentUrl.includes('searchorders')) {
          $('#searchorders').addClass('active');
        } else {
          $('#searchorders').removeClass('active');
        }
      });

    // use BehaviorSubject to watch the changes of search keywords
    if (this.activeRouter.snapshot.children[0]) {
      this.searchField = this.activeRouter.snapshot.children[0].paramMap.get('searchparm');
    }

    this.orderService.monitorSearchKeyWordChange(this.searchField);

    this.orderService.currentWatch.subscribe((res: string) => {
      this.searchField = res;
    });

    this.activeRouter.url.subscribe(value => {
      if (value.length === 0) {
        $('.page-contents').animate({ scrollLeft: 0 }, 400);
      }
    });
  }


  navigateTo(url: string) {
    this.router.navigate([url]);
  }

  search(field: string) {
    if (field.length === 0) {
      return;
    }
    const originalSearchKey = field;
    field = encodeURIComponent(field);
    this.orderService.monitorSearchKeyWordChange(field);
    // this.router.navigateByUrl('/myOrder/searchorders/' + field);
    this.router.navigate(['/myOrder/searchorders/' + field], {
      relativeTo: this.activeRouter,
    });
    this.searchField = originalSearchKey;
  }

  ngOnDestroy(): void {
  }

  close() {
    this.entry.clear();
    this.created = false;
  }
}
